<template>
  <div class="admin-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="12">
      <Button @click="showCreate()"
              type="success"
              class="f-r">添加管理员</Button>
      </Col>
    </Row>
    <Table border
           :columns="list"
           ref="roleList"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showCreateStatus"
           title="添加管理员"
           @on-ok="createAdmin('adminCreateValidate')"
           :loading="loading">
      <Form :model="adminInfo"
            ref="adminCreateValidate"
            :rules="adminCreateValidate"
            action="javascript:void(0)">
        <FormItem label="部门"
                  prop="section_id">
          <Select v-model="adminInfo.section_id"
                  ref="sectionid">
            <Option v-for="item in sectionList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="角色">
          <CheckboxGroup v-model="adminInfo.role_ids"
                         @on-change="roleCheck">
            <Checkbox v-for="item in roleList"
                      :key="item.id"
                      :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="用户名"
                  prop="name">
          <Input v-model="adminInfo.name"
                 placeholder="输入用户名..."></Input>
        </FormItem>
        <FormItem label="姓名"
                  prop="realname">
          <Input v-model="adminInfo.realname"
                 placeholder="输入姓名..."></Input>
        </FormItem>
        <FormItem label="头像">
          <upload-thumb v-model="adminInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="200"
                        :autoCropHeight="200"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:200*200,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="adminInfo.phone"
                 placeholder="输入手机号..."></Input>
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="adminInfo.email"
                 placeholder="输入邮箱..."></Input>
        </FormItem>
        <FormItem label="密码( 必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _ )"
                  prop="password">
          <Input v-model="adminInfo.password"
                 type="password"
                 placeholder="输入密码..."></Input>
        </FormItem>
        <FormItem label="确认密码">
          <Input v-model="adminInfo.password_confirmation"
                 type="password"
                 placeholder="确认密码..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改资料 -->
    <Modal v-model="showEditInfoStatus"
           title="修改资料"
           @on-ok="updateAdmin('adminEditValidate')"
           :loading="loading">
      <Form :model="adminInfo"
            ref="adminEditValidate"
            :rules="adminEditValidate"
            action="javascript:void(0)">
        <FormItem label="部门"
                  prop="section_id">
          <Select v-model="adminInfo.section_id">
            <Option v-for="item in sectionList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="角色">
          <CheckboxGroup v-model="adminInfo.role_ids"
                         @on-change="roleCheck">
            <Checkbox v-for="item in roleList"
                      :key="item.id"
                      :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="用户名"
                  prop="name">
          <Input v-model="adminInfo.name"
                 disabled
                 placeholder="输入用户名..."></Input>
        </FormItem>
        <FormItem label="姓名"
                  prop="realname">
          <Input v-model="adminInfo.realname"
                 placeholder="输入姓名..."></Input>
        </FormItem>
        <FormItem label="头像">
          <upload-thumb v-model="adminInfo.thumb"
                        ref="uploadthumbtwo"
                        :defaultList="thumblist2"
                        :autoCropWidth="200"
                        :autoCropHeight="200"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:200*200,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="adminInfo.phone"
                 placeholder="输入手机号..."></Input>
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="adminInfo.email"
                 placeholder="输入邮箱..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改密码 -->
    <Modal v-model="showEditPwdStatus"
           title="修改密码"
           @on-ok="updatePassword('adminPasswordValidate')"
           :loading="loading">
      <Form :model="adminPwd"
            ref="adminPasswordValidate"
            :rules="adminPasswordValidate"
            action="javascript:void(0)">
        <FormItem label="密码( 必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _ )"
                  prop="password">
          <Input v-model="adminPwd.password"
                 type="password"
                 placeholder="输入密码..."></Input>
        </FormItem>
        <FormItem label="确认密码"
                  prop="password_confirmation">
          <Input v-model="adminPwd.password_confirmation"
                 type="password"
                 placeholder="确认密码..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 区域 -->
    <Modal v-model="showAreaStatus"
           title="管理区域"
           @on-ok="updateArea()"
           :loading="loading">
      <Form :model="adminarea"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="adminarea.area1"
                  multiple
                  placeholder="省"
                  @on-change="shengChange">
            <Option v-for="item in shengList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="adminarea.area2"
                  multiple
                  placeholder="市"
                  @on-change="shiChange">
            <Option v-for="item in shiList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="adminarea.area3"
                  multiple
                  placeholder="县">
            <Option v-for="item in quList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import md5 from "js-md5";

export default {
  name: "admin-list",
  data () {
    const pwdCheck = (rule, value, callback) => {
      let numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
      let englishAlphabet = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f',
        'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'];
      let specialCharacters = ['!', '@', '#', '$', '%', '&', '.', '_'];
      let isNumber = false;
      let isEnglishAlphabet = false;
      let isBigEnglishAlphabet = false;
      let isSpecialCharacters = false;
      numbers.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isNumber = true;
        }
      });
      englishAlphabet.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isEnglishAlphabet = true;
        }
        if (value.indexOf(item.toUpperCase()) !== -1) {
          isBigEnglishAlphabet = true;
        }
      });
      specialCharacters.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isSpecialCharacters = true;
        }
      });
      if (isNumber && isEnglishAlphabet && isBigEnglishAlphabet && isSpecialCharacters) {
        callback();
      } else {
        callback(new Error("密码格式错误"));
      }
    };
    return {
      loading: true,
      dataloading: true,
      admin_id: 0,
      thumblist: [],
      thumblist2: [],
      formItem: {
        key: ""
      },
      pages: {
        page: 1,
        size: 10
      },
      list: [
        {
          title: "Id",
          key: "id",
          width: 80,
          fixed: "left"
        },
        {
          title: "用户名",
          Width: 150,
          key: "name"
        },
        {
          title: "姓名",
          width: 150,
          key: "realname"
        },
        {
          title: "电话",
          width: 150,
          key: "phone"
        },
        {
          title: "邮箱",
          width: 150,
          key: "email"
        },
        {
          title: "最后登录时间",
          width: 180,
          key: "lasttime"
        },
        {
          title: "最后登录IP",
          width: 120,
          key: "lastip"
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 300,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showArea(params.row.id);
                    }
                  }
                },
                "区域"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showEditPwd(params.row.id);
                    }
                  }
                },
                "改密"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      roleList: [],
      sectionList: [],
      shengList: [],
      shiList: [],
      quList: [],
      adminInfo: {
        section_id: 0,
        role_ids: [],
        name: "",
        realname: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: ""
      },
      adminPwd: {
        password: "",
        password_confirmation: ""
      },
      adminarea: {},
      showCreateStatus: false,
      showEditInfoStatus: false,
      showEditPwdStatus: false,
      showAreaStatus: false,
      adminCreateValidate: {
        name: [
          { required: true, message: "用户名必须填写", trigger: "blur" },
          {
            type: "string",
            min: 2,
            max: 15,
            message: "用户名 3 - 15 位长度",
            trigger: "blur"
          }
        ],
        realname: [
          { required: true, message: "姓名必须填写", trigger: "blur" },
          {
            type: "string",
            min: 2,
            max: 15,
            message: "姓名 3 - 15 位长度",
            trigger: "blur"
          }
        ],
        section_id: [
          {
            required: true,
            message: "部门必须选择",
            trigger: "change",
            type: "number"
          },
          {
            validator: function (rule, value, callback) {
              if (!value) {
                return callback(new Error("部门必须选择"));
              } else if (value < 1) {
                return callback(new Error("部门必须选择"));
              } else {
                callback();
              }
            },
            trigger: "change",
            type: "number"
          }
        ],
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur",
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
      },
      adminEditValidate: {
        realname: [
          { required: true, message: "姓名必须填写", trigger: "blur" },
          {
            type: "string",
            min: 2,
            max: 15,
            message: "姓名 3 - 15 位长度",
            trigger: "blur"
          }
        ],
        section_id: [
          {
            required: true,
            message: "部门必须选择",
            trigger: "blur",
            type: "number"
          }
        ]
      },
      adminPasswordValidate: {
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur",
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: "请重新输入密码", trigger: "blur" },
        ]
      },
      role_ids: []
    };
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getSectionRole();
    this.getShengList();
  },
  components: {
    UploadThumb
  },
  methods: {
    getTableList: function () {
      this.$api.admin.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 获取部门及角色列表
    getSectionRole () {
      this.$api.role.list().then(res => {
        if (res.code == 200) {
          this.roleList = res.result.list;
        }
      });
      this.$api.section.list().then(res => {
        if (res.code == 200) {
          this.sectionList = res.result.list;
        }
      });
    },
    // 展开添加
    showCreate () {
      this.admin_id = 0;
      this.adminInfo = {
        section_id: 0,
        role_ids: [],
        name: "",
        realname: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: ""
      };
      this.thumblist = [];
      this.thumblist2 = [];
      this.$refs["adminCreateValidate"].resetFields();
      this.showCreateStatus = !this.showCreateStatus;
    },
    // 选中角色时
    roleCheck (data) {
      this.role_ids = data;
    },
    // 添加
    createAdmin (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.adminInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          }
          this.$api.admin
            .create({
              section_id: this.adminInfo.section_id,
              role_ids: this.role_ids,
              name: this.adminInfo.name,
              realname: this.adminInfo.realname,
              thumb: this.adminInfo.thumb,
              phone: this.adminInfo.phone,
              email: this.adminInfo.email,
              password: md5(this.adminInfo.password),
              password_confirmation: md5(this.adminInfo.password_confirmation)
            })
            .then(res => {
              if (res.code == 200) {
                this.adminInfo.name = "";
                this.adminInfo.section_id = 0;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showCreateStatus = !this.showCreateStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 展开修改
    showEditInfo (value) {
      this.admin_id = value;
      this.adminInfo = {
        section_id: 0,
        role_ids: [],
        name: "",
        realname: "",
        phone: "",
        email: "",
        password: "",
        password_confirmation: ""
      };
      this.$refs["adminCreateValidate"].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.admin.detail({ admin_id: value }).then(res => {
        if (res.code == 200) {
          this.adminInfo = res.result;
          if (this.adminInfo.thumb) {
            this.thumblist2.push({
              name: this.adminInfo.thumb,
              url: this.adminInfo.thumb,
              status: "finished"
            });
          }
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    //区域
    showArea (value) {
      this.admin_id = value;
      this.showAreaStatus = !this.showAreaStatus;
      this.$api.admin.arealist({ id: this.admin_id }).then(res => {
        if (res.code == 200) {
          //省市区三个下拉框
          var sheng = res.result.area1.split(",");
          var shengList = [];
          for (let i = 0; i < sheng.length; i++) {
            const area = sheng[i];
            shengList.push(parseInt(area));
          }
          var shi = res.result.area2.split(",");
          var shiList = [];
          for (let i = 0; i < shi.length; i++) {
            const area = shi[i];
            shiList.push(parseInt(area));
          }
          var qu = res.result.area3.split(",");
          var quList = [];
          for (let i = 0; i < qu.length; i++) {
            const area = qu[i];
            quList.push(parseInt(area));
          }
          this.adminarea.area1 = shengList;
          this.adminarea.area2 = shiList;
          this.adminarea.area3 = quList;
          this.shengChange(shengList);
          this.shiChange(shiList);
          // this.shiList = res.result.shiList;
          // this.quList = res.result.quList;
          console.log("this.adminarea:", this.adminarea);
        }
      });
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.secondarea({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.secondarea({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    // 展开修改密码
    showEditPwd (value) {
      this.admin_id = value;
      this.showEditPwdStatus = !this.showEditPwdStatus;
    },
    // 修改名称
    updateAdmin: function (name) {
      this.$refs[name].validate(valid => {
        if (this.$refs["uploadthumbtwo"].uploadList.length > 0) {
          this.adminInfo.thumb = this.$refs["uploadthumbtwo"].uploadList[0].url;
        }
        if (valid) {
          this.$api.admin
            .editinfo({
              admin_id: this.admin_id,
              section_id: this.adminInfo.section_id,
              role_ids: this.role_ids,
              realname: this.adminInfo.realname,
              thumb: this.adminInfo.thumb,
              phone: this.adminInfo.phone,
              email: this.adminInfo.email
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditInfoStatus = !this.showEditInfoStatus;
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              // this.showCreateStatus = !this.showCreateStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //更新区域
    updateArea: function (index) {
      if (this.admin_id != "" || this.admin_id != 0) {
        this.$api.admin
          .createarea({ adminarea: this.adminarea, id: this.admin_id })
          .then(res => {
            if (res.code == 200) {
              this.showAreaStatus = false;
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
      }
    },
    // 修改密码
    updatePassword: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.adminPwd.password != this.adminPwd.password_confirmation) {
            this.$Message.error("两次密码不一致");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$api.admin
            .editpassword({
              admin_id: this.admin_id,
              password: md5(this.adminPwd.password),
              password_confirmation: md5(this.adminPwd.password_confirmation)
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showEditPwdStatus = !this.showEditPwdStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.admin.remove({ admin_id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.admin.status({ admin_id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.admin.list(ps).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
        this.dataloading = false;
      });
      return;
    }
  }
};
</script>
